// extracted by mini-css-extract-plugin
module.exports = {"burgerIcon":"p4","cross":"p5","iconSVGWrapper":"p6","iconSVG":"p7","iconSVGDark":"p8"};